/**
 * Parsea una línea CSV respetando comillas dobles (RFC básico).
 * @param {string} line
 * @returns {string[]}
 */
export function parseCsvLine(line) {
  const result = [];
  let cur = '';
  let inQuotes = false;
  for (let i = 0; i < line.length; i += 1) {
    const c = line[i];
    if (c === '"') {
      if (inQuotes && line[i + 1] === '"') {
        cur += '"';
        i += 1;
      } else {
        inQuotes = !inQuotes;
      }
    } else if ((c === ',' && !inQuotes) || c === '\r') {
      result.push(cur.trim());
      cur = '';
    } else {
      cur += c;
    }
  }
  result.push(cur.trim());
  return result;
}

function normalizeHeaderCell(cell) {
  return cell
    .replace(/^"|"$/g, '')
    .replace(/^#+\s*/, '')
    .trim()
    .toLowerCase();
}

function dedupePins(list) {
  const seen = new Set();
  const out = [];
  list.forEach((p) => {
    const t = String(p).trim();
    if (!t || seen.has(t)) return;
    seen.add(t);
    out.push(t);
  });
  return out;
}

/**
 * Extrae pines de texto pegado o de CSV (columna Pin / pin / PIN, o lista separada por comas).
 * @param {string} text
 * @returns {string[]}
 */
export function extractPinsFromCsvOrList(text) {
  const raw = String(text || '').replace(/^\uFEFF/, '');
  const lines = raw.split(/\r?\n/).map((l) => l.trim()).filter((l) => l.length > 0);
  if (lines.length === 0) return [];

  const firstRow = parseCsvLine(lines[0]);
  const pinCol = firstRow.findIndex((cell) => normalizeHeaderCell(cell) === 'pin');

  if (pinCol >= 0) {
    const out = [];
    for (let i = 1; i < lines.length; i += 1) {
      const row = parseCsvLine(lines[i]);
      let p = (row[pinCol] || '').replace(/^"|"$/g, '').trim();
      if (p) out.push(p);
    }
    return dedupePins(out);
  }

  const allRows = lines.map((l) => parseCsvLine(l));
  if (allRows.length > 0 && allRows.every((r) => r.length === 1)) {
    return dedupePins(
      allRows.map((r) => r[0].replace(/^"|"$/g, '').trim()).filter(Boolean),
    );
  }

  const out = [];
  lines.forEach((line) => {
    line.split(',').forEach((part) => {
      const p = part.trim().replace(/^"|"$/g, '');
      if (p) out.push(p);
    });
  });
  return dedupePins(out);
}

/**
 * Separa pines escritos manualmente separados por coma (sin lógica CSV multilínea).
 * @param {string} input
 * @returns {string[]}
 */
export function extractPinsFromCommaInput(input) {
  return dedupePins(
    String(input || '')
      .split(',')
      .map((p) => p.trim().replace(/^"|"$/g, ''))
      .filter(Boolean),
  );
}
